// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newsletter":"css-f9HE-B4biE"};